<app-card-relatorio-laudo [titulo]="template.label" [status]="template.status">
  <app-lista-titulo-desc [elements]="template.elements"></app-lista-titulo-desc>
  <div class="row">
    <div class="col-12" *ngIf="foto">
      <app-lista-img [elements]="[foto]" [cols]="12"></app-lista-img>
    </div>
    <div class="col-12 px-2 py-4" *ngIf="parecer">
      <div class="d-flex justify-content-between align-items-center">
        <div class="text-secondary f-12">{{ parecer?.label }}</div>
        <div
          class="rounded m-1 py-2 px-3 px-md-4 px-lg-5 text-white"
          [ngClass]="{
            'bg-success': parecer.status < 2,
            'bg-warning': parecer.status > 1 && parecer.status < 4,
            'bg-danger': parecer.status > 3
          }"
        >
          {{ parecer.value }}
        </div>
      </div>
      <div style="margin-top: 10px">
        <strong style="white-space: pre-line;"> {{ textoObservacao | uppercase }} </strong>
      </div>
      <div *ngIf="textoPadrao != ''" style="margin-top: 10px">
        <div class="text-secondary">{{ parecerObs?.label }}</div>
        <div style="white-space: pre-line;">{{ textoPadrao }}</div>
      </div>
    </div>
  </div>
</app-card-relatorio-laudo>
